/**
 * Overdue: a date before today, on work that is not finished.
 *
 * **The one copy for the pages that work it out themselves** (punch list
 * F150, 30 Oct 2026): the task page's task and stage dates, the project and
 * deliverable pages' "Overdue", and My calendar's "Late · n days", which had
 * it inline. The server says the same thing in SQL -- `due_date <
 * CURRENT_DATE` on open work, behind My work's "n days late" and Needs
 * attention's C2 and C3 -- which cannot import this; change one, change both.
 *
 * Plain calendar days, never business days (`dates.ts`): a stage due on
 * Friday is a day late on Saturday. Today is an ARGUMENT, the reader's own
 * calendar day, so nothing here reads the clock.
 */
const DAY_MS = 24 * 60 * 60 * 1000;
const utcOf = (iso) => Date.UTC(Number(iso.slice(0, 4)), Number(iso.slice(5, 7)) - 1, Number(iso.slice(8, 10)));
/**
 * How many days `due` is behind `today` (both `YYYY-MM-DD`), or null when it
 * is not overdue: undated, due today or later, or the work is `finished` --
 * done or cancelled, or a stage complete. Due yesterday is 1.
 */
export function daysOverdue(due, today, finished = false) {
    if (finished || due === null || !(due < today))
        return null;
    return Math.round((utcOf(today) - utcOf(due)) / DAY_MS);
}
//# sourceMappingURL=overdue.js.map